import { render } from "./vaults.vue?vue&type=template&id=4a0cf715&scoped=true&ts=true"
import script from "./vaults.vue?vue&type=script&lang=ts"
export * from "./vaults.vue?vue&type=script&lang=ts"

import "./vaults.vue?vue&type=style&index=0&id=4a0cf715&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a0cf715"]])

export default __exports__